export const HEADER_SIO_INIT = "HEADER_SIO_INIT"
export const HEADER_SIO_INIT_SUCCESS = "HEADER_SIO_INIT_SUCCESS"
